export const Courses = {
  course: [
    "Distributed Systems",
    "Compilers",
    "Operating Systems",
    "Object Oriented Programming (Java)",
    "Data Mining",
    "Software Development",
    "Machine Learning",
    "Concurrent Programming",
    "DBMS",
    "C Programming Language",
  ],
};
